import { gql, TypedDocumentNode } from '@common/hooks';
import {
  SuppliersQueryVariables,
  SuppliersQueryCgResponse,
} from '@common/graphql';

export type SupplierListItemType =
  SuppliersQueryCgResponse['suppliers'][number];

export const SUPPLIERS_QUERY: TypedDocumentNode<
  SuppliersQueryCgResponse,
  SuppliersQueryVariables
> = gql`
  query Suppliers($input: SuppliersInput) {
    suppliers(input: $input) {
      id
      name
      phoneNumber
      defaultContact {
        id
        name
        email
      }
      statusForCurrentOrganization {
        id
        status
      }
      tierForCurrentOrganization {
        id
        name
      }
    }
  }
`;
